<template>
  <Modal
    title="Annual leave detail"
    type="primary"
    className="annual-leave-overview-modal"
    @onCancel="$emit('onCancel')"
    :visible="visibleModal"
    :viewDetail="true"
    :isCustomButton="true"
    :width="1200"
  >
    <a-row :gutter="[0, 24]">
      <a-col :span="24">
        <a-form v-bind="formItemLayout" labelAlign="left" :colon="false" class="form-detail">
          <a-row :gutter="[48, 6]">
            <a-col v-for="{ key, label, width } in annualLeaveDetails" :key="key" :span="width === 100 ? 24 : 12">
              <a-form-item :label="label">
                {{ generateValue(key) }}
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-col>
      <a-col :span="24">
        <Table
          :columns="columns"
          :data="data.details"
          :pagination="false"
          rowKey="key"
          :scrollX="false"
          className="annual-leave-details"
          :slots="['currentAnnualLeave', 'lastPeriodAnnualLeave']"
        >
          <a-row v-for="{ key, title, subTitle } in slots" :slot="key" :key="key">
            <a-col :span="24">{{ title }}</a-col>
            <a-col :span="24">
              {{ subTitle }}
            </a-col>
          </a-row>
        </Table>
      </a-col>
    </a-row>
    <template slot="button">
      <Button type="primary" @click="$emit('onCancel')">Close</Button>
    </template>
  </Modal>
</template>

<script>
import { Modal, Button, Table } from "@/components";
import { toFixedNumber } from "@/utils";
const annualLeaveDetails = [
  {
    key: "rangeTimesheet",
    label: "Kỳ công",
    width: 50,
  },
  {
    key: "fullName",
    label: "Nhân viên",
    width: 50,
  },
];
const columns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 60,
  },
  {
    title: "Qũy phép",
    dataIndex: "annualLeaveType",
    key: "annualLeaveType",
    width: 160,
  },
  {
    title: "Phép khả dụng đầu kỳ (giờ) (A)",
    dataIndex: "availability_begin_period",
    key: "availability_begin_period",
    customRender(value) {
      return toFixedNumber(value);
    },
    width: 120,
    class: "value",
    align: "right",
  },
  {
    title: "Phép được cộng thêm (giờ) (B)",
    dataIndex: "addition_leave",
    key: "addition_leave",
    customRender(value) {
      return toFixedNumber(value);
    },
    width: 120,
    class: "value",
    align: "right",
  },
  {
    title: "Phép đã dùng (giờ) (C)",
    dataIndex: "used_in_period",
    key: "used_in_period",
    customRender(value) {
      return toFixedNumber(value);
    },
    width: 120,
    class: "value",
    align: "right",
  },
  {
    title: "Phép hết hạn (giờ) (D)",
    dataIndex: "expired",
    key: "expired",
    customRender(value) {
      return toFixedNumber(value);
    },
    width: 120,
    class: "value",
    align: "right",
  },
  {
    dataIndex: "current_leave_fund_availability",
    key: "current_leave_fund_availability",
    slots: { title: "currentAnnualLeave" },
    customRender(value) {
      return toFixedNumber(value);
    },
    width: 200,
    class: "value",
    align: "right",
  },
  {
    dataIndex: "leave_fund_availability_end_of_period",
    key: "leave_fund_availability_end_of_period",
    slots: { title: "lastPeriodAnnualLeave" },
    customRender(value) {
      return toFixedNumber(value);
    },
    width: 200,
    class: "value",
    align: "right",
  },
];

const slots = [
  {
    key: "currentAnnualLeave",
    title: "Phép được dùng hiện tại",
    subTitle: "(giờ) (E=A + B - C - D)",
  },
  {
    key: "lastPeriodAnnualLeave",
    title: "Phép khả dụng cuối kỳ",
    subTitle: "(giờ) (E=A + B - C - D)",
  },
];
export default {
  name: "AnnualLeaveModal",
  components: {
    Modal,
    Button,
    Table,
  },
  emits: ["onCancel"],
  props: {
    visibleModal: {
      type: Boolean,
      require: true,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      annualLeaveDetails,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
      },
      columns,
      slots,
    };
  },
  methods: {
    generateValue(key) {
      const { data } = this;
      if (!data) return "";
      switch (key) {
        case "fullName":
          return data[key];
        default:
          return `${data[key] ?? ""}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .form-detail {
  .ant-form-item {
    border-bottom: 2px solid #cdebf9;
    padding: 6px 0px;
    margin-bottom: 0;
    label {
      line-height: 24px;
      color: #61757d;
    }
    .ant-form-item-children {
      color: #29444f;
    }
  }
}
.annual-leave-details {
  ::v-deep tr[data-row-key="total_leave_detail"] {
    color: red;
    .value {
      color: #29444f;
      font-weight: 700;
    }
  }
}

@media screen and (min-width: 1200px) {
  ::v-deep .annual-leave-overview-modal {
    width: 1200px;
  }
}
@media screen and (min-width: 992px) {
  ::v-deep .annual-leave-overview-modal {
    width: 800px;
  }
}
</style>
